<template>
	<div class="m-list-product-info">
		<p class="product-name">
            <c-state v-if="level" tag async dict="LEVEL_TYPE" :value="level"></c-state>
			<span>{{name || '-'}}</span>
		</p>
		<p class="product-code">背贴码：{{code || '-'}} <c-link v-if="code" color="gray" @click="$copy(code)"><i class="tf">&#xe6b0;</i></c-link></p>
		<p class="product-code">IMEI：{{imei || '-'}} <c-link v-if="imei" color="gray" @click="$copy(imei)"><i class="tf">&#xe6b0;</i></c-link></p>
	</div>
</template>

<script>
	export default {
		name: 'mProductInfo',
		props: {
			name: String,
			level: [Number, String],
			code: String,
			imei: String
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		p {
			margin: 0;
		}

		.product-name {
			display: flex;
			align-items: center;
			gap: 4px;

			.c-state {
				flex-shrink: 0;
			}
		}

		.product-code {
			color: #999;
			font-size: 12px;
			white-space: nowrap;
		}
	}
</style>
